import * as Yup from 'yup'

const unSdgSchema = Yup.object().shape({
  name: Yup.string().max(100, 'validation-name-max').required('validation-required'),
  description: Yup.string().max(30000, 'validation-description-max').nullable(),
  image: Yup.object().shape({
    icon: Yup.string().required('validation-required'),
  }),
  more_info_url: Yup.string().url('validation-url-invalid').nullable(),
})

export { unSdgSchema }
